module.exports = __webpack_public_path__ + "static/img/r-2-3-icon.c49f9c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/en/role-2/r-2-3-icon.png
// module id = YNFZ
// module chunks = 0